import React, { useState, useEffect } from "react";
import {
  FormControl,
  FormLabel,
  Input,
  Select,
  Textarea,
  InputGroup,
  InputLeftElement,
} from "@chakra-ui/react";
import "./DynamicForm.css";
import axios from "axios";
import UserDataForm from "./UserData";
import { FaFilePdf, FaFileWord, FaFileImage } from "react-icons/fa";
import { MultiSelect } from "chakra-multiselect";


const timezones = [
  'Asia/Abudhabi',
  'Europe/Andorra',
  'Asia/Dubai',
  'Asia/Kabul',
  'Europe/Tirane',
  'Asia/Yerevan',
  'Antarctica/Casey',
  'Antarctica/Davis',
  'Antarctica/DumontDUrville',
  'Antarctica/Mawson',
  'Antarctica/Palmer',
  'Antarctica/Rothera',
  'Antarctica/Syowa',
  'Antarctica/Troll',
  'Antarctica/Vostok',
  'America/Argentina/Buenos_Aires',
  'America/Argentina/Cordoba',
  'America/Argentina/Salta',
  'America/Argentina/Jujuy',
  'America/Argentina/Tucuman',
  'America/Argentina/Catamarca',
  'America/Argentina/La_Rioja',
  'America/Argentina/San_Juan',
  'America/Argentina/Mendoza',
  'America/Argentina/San_Luis',
  'America/Argentina/Rio_Gallegos',
  'America/Argentina/Ushuaia',
  'Pacific/Pago_Pago',
  'Europe/Vienna',
  'Australia/Lord_Howe',
  'Antarctica/Macquarie',
  'Australia/Hobart',
  'Australia/Currie',
  'Australia/Melbourne',
  'Australia/Sydney',
  'Australia/Broken_Hill',
  'Australia/Brisbane',
  'Australia/Lindeman',
  'Australia/Adelaide',
  'Australia/Darwin',
  'Australia/Perth',
  'Australia/Eucla',
  'Asia/Baku',
  'America/Barbados',
  'Asia/Dhaka',
  'Europe/Brussels',
  'Europe/Sofia',
  'Atlantic/Bermuda',
  'Asia/Brunei',
  'America/La_Paz',
  'America/Noronha',
  'America/Belem',
  'America/Fortaleza',
  'America/Recife',
  'America/Araguaina',
  'America/Maceio',
  'America/Bahia',
  'America/Sao_Paulo',
  'America/Campo_Grande',
  'America/Cuiaba',
  'America/Santarem',
  'America/Porto_Velho',
  'America/Boa_Vista',
  'America/Manaus',
  'America/Eirunepe',
  'America/Rio_Branco',
  'America/Nassau',
  'Asia/Thimphu',
  'Europe/Minsk',
  'America/Belize',
  'America/St_Johns',
  'America/Halifax',
  'America/Glace_Bay',
  'America/Moncton',
  'America/Goose_Bay',
  'America/Blanc-Sablon',
  'America/Toronto',
  'America/Nipigon',
  'America/Thunder_Bay',
  'America/Iqaluit',
  'America/Pangnirtung',
  'America/Atikokan',
  'America/Winnipeg',
  'America/Rainy_River',
  'America/Resolute',
  'America/Rankin_Inlet',
  'America/Regina',
  'America/Swift_Current',
  'America/Edmonton',
  'America/Cambridge_Bay',
  'America/Yellowknife',
  'America/Inuvik',
  'America/Creston',
  'America/Dawson_Creek',
  'America/Fort_Nelson',
  'America/Vancouver',
  'America/Whitehorse',
  'America/Dawson',
  'Indian/Cocos',
  'Europe/Zurich',
  'Africa/Abidjan',
  'Pacific/Rarotonga',
  'America/Santiago',
  'America/Punta_Arenas',
  'Pacific/Easter',
  'Asia/Shanghai',
  'Asia/Urumqi',
  'America/Bogota',
  'America/Costa_Rica',
  'America/Havana',
  'Atlantic/Cape_Verde',
  'America/Curacao',
  'Indian/Christmas',
  'Asia/Nicosia',
  'Asia/Famagusta',
  'Europe/Prague',
  'Europe/Berlin',
  'Europe/Copenhagen',
  'America/Santo_Domingo',
  'Africa/Algiers',
  'America/Guayaquil',
  'Pacific/Galapagos',
  'Europe/Tallinn',
  'Africa/Cairo',
  'Africa/El_Aaiun',
  'Europe/Madrid',
  'Africa/Ceuta',
  'Atlantic/Canary',
  'Europe/Helsinki',
  'Pacific/Fiji',
  'Atlantic/Stanley',
  'Pacific/Chuuk',
  'Pacific/Pohnpei',
  'Pacific/Kosrae',
  'Atlantic/Faroe',
  'Europe/Paris',
  'Europe/London',
  'Asia/Tbilisi',
  'America/Cayenne',
  'Africa/Accra',
  'Europe/Gibraltar',
  'America/Godthab',
  'America/Danmarkshavn',
  'America/Scoresbysund',
  'America/Thule',
  'Europe/Athens',
  'Atlantic/South_Georgia',
  'America/Guatemala',
  'Pacific/Guam',
  'Africa/Bissau',
  'America/Guyana',
  'Asia/Hong_Kong',
  'America/Tegucigalpa',
  'America/Port-au-Prince',
  'Europe/Budapest',
  'Asia/Jakarta',
  'Asia/Pontianak',
  'Asia/Makassar',
  'Asia/Jayapura',
  'Europe/Dublin',
  'Asia/Jerusalem',
  'Asia/Kolkata',
  'Indian/Chagos',
  'Asia/Baghdad',
  'Asia/Tehran',
  'Atlantic/Reykjavik',
  'Europe/Rome',
  'America/Jamaica',
  'Asia/Amman',
  'Asia/Tokyo',
  'Africa/Nairobi',
  'Asia/Bishkek',
  'Pacific/Tarawa',
  'Pacific/Enderbury',
  'Pacific/Kiritimati',
  'Asia/Pyongyang',
  'Asia/Seoul',
  'Asia/Almaty',
  'Asia/Qyzylorda',
  'Asia/Qostanay',
  'Asia/Aqtobe',
  'Asia/Aqtau',
  'Asia/Atyrau',
  'Asia/Oral',
  'Asia/Beirut',
  'Asia/Colombo',
  'Africa/Monrovia',
  'Europe/Vilnius',
  'Europe/Luxembourg',
  'Europe/Riga',
  'Africa/Tripoli',
  'Africa/Casablanca',
  'Europe/Monaco',
  'Europe/Chisinau',
  'Pacific/Majuro',
  'Pacific/Kwajalein',
  'Asia/Yangon',
  'Asia/Ulaanbaatar',
  'Asia/Hovd',
  'Asia/Choibalsan',
  'Asia/Macau',
  'America/Martinique',
  'Europe/Malta',
  'Indian/Mauritius',
  'Indian/Maldives',
  'America/Mexico_City',
  'America/Cancun',
  'America/Merida',
  'America/Monterrey',
  'America/Matamoros',
  'America/Mazatlan',
  'America/Chihuahua',
  'America/Ojinaga',
  'America/Hermosillo',
  'America/Tijuana',
  'America/Bahia_Banderas',
  'Asia/Kuala_Lumpur',
  'Asia/Kuching',
  'Africa/Maputo',
  'Africa/Windhoek',
  'Pacific/Noumea',
  'Pacific/Norfolk',
  'Africa/Lagos',
  'America/Managua',
  'Europe/Amsterdam',
  'Europe/Oslo',
  'Asia/Kathmandu',
  'Pacific/Nauru',
  'Pacific/Niue',
  'Pacific/Auckland',
  'Pacific/Chatham',
  'America/Panama',
  'America/Lima',
  'Pacific/Tahiti',
  'Pacific/Marquesas',
  'Pacific/Gambier',
  'Pacific/Port_Moresby',
  'Pacific/Bougainville',
  'Asia/Manila',
  'Asia/Karachi',
  'Europe/Warsaw',
  'America/Miquelon',
  'Pacific/Pitcairn',
  'America/Puerto_Rico',
  'Asia/Gaza',
  'Asia/Hebron',
  'Europe/Lisbon',
  'Atlantic/Madeira',
  'Atlantic/Azores',
  'Pacific/Palau',
  'America/Asuncion',
  'Asia/Qatar',
  'Indian/Reunion',
  'Europe/Bucharest',
  'Europe/Belgrade',
  'Europe/Kaliningrad',
  'Europe/Moscow',
  'Europe/Simferopol',
  'Europe/Kirov',
  'Europe/Astrakhan',
  'Europe/Volgograd',
  'Europe/Saratov',
  'Europe/Ulyanovsk',
  'Europe/Samara',
  'Asia/Yekaterinburg',
  'Asia/Omsk',
  'Asia/Novosibirsk',
  'Asia/Barnaul',
  'Asia/Tomsk',
  'Asia/Novokuznetsk',
  'Asia/Krasnoyarsk',
  'Asia/Irkutsk',
  'Asia/Chita',
  'Asia/Yakutsk',
  'Asia/Khandyga',
  'Asia/Vladivostok',
  'Asia/Ust-Nera',
  'Asia/Magadan',
  'Asia/Sakhalin',
  'Asia/Srednekolymsk',
  'Asia/Kamchatka',
  'Asia/Anadyr',
  'Asia/Riyadh',
  'Pacific/Guadalcanal',
  'Indian/Mahe',
  'Africa/Khartoum',
  'Europe/Stockholm',
  'Asia/Singapore',
  'America/Paramaribo',
  'Africa/Juba',
  'Africa/Sao_Tome',
  'America/El_Salvador',
  'Asia/Damascus',
  'America/Grand_Turk',
  'Africa/Ndjamena',
  'Indian/Kerguelen',
  'Asia/Bangkok',
  'Asia/Dushanbe',
  'Pacific/Fakaofo',
  'Asia/Dili',
  'Asia/Ashgabat',
  'Africa/Tunis',
  'Pacific/Tongatapu',
  'Europe/Istanbul',
  'America/Port_of_Spain',
  'Pacific/Funafuti',
  'Asia/Taipei',
  'Europe/Kiev',
  'Europe/Uzhgorod',
  'Europe/Zaporozhye',
  'Pacific/Wake',
  'America/New_York',
  'America/Detroit',
  'America/Kentucky/Louisville',
  'America/Kentucky/Monticello',
  'America/Indiana/Indianapolis',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Indiana/Marengo',
  'America/Indiana/Petersburg',
  'America/Indiana/Vevay',
  'America/Chicago',
  'America/Indiana/Tell_City',
  'America/Indiana/Knox',
  'America/Menominee',
  'America/North_Dakota/Center',
  'America/North_Dakota/New_Salem',
  'America/North_Dakota/Beulah',
  'America/Denver',
  'America/Boise',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'America/Juneau',
  'America/Sitka',
  'America/Metlakatla',
  'America/Yakutat',
  'America/Nome',
  'America/Adak',
  'Pacific/Honolulu',
  'America/Montevideo',
  'Asia/Samarkand',
  'Asia/Tashkent',
  'America/Caracas',
  'Asia/Ho_Chi_Minh',
  'Pacific/Efate',
  'Pacific/Wallis',
  'Pacific/Apia',
  'Africa/Johannesburg'
];


const DynamicForm = ({
  formData,
  activeForm,
  setActiveForm,
  completeForm,
  setFormVisible,
  isFormVisible,
  setFormSubmitted,
  formSubmitted,
  
}) => {
  const [currentForm, setCurrentForm] = useState(null);
  const [formValues, setFormValues] = useState({});
  const [formHistory, setFormHistory] = useState([]);
  const [formDataArray, setFormDataArray] = useState([]);
  const [fileUploadState, setFileUploadState] = useState({});
  const [accumulatedData, setAccumulatedData] = useState({});
  // const [value, setValue] = useState([])

  // const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    if (formData && formData.forms) {
      const initialFormId = formData.forms.find(
        (form) => form.name === activeForm
      )?.id;
      if (initialFormId) {
        setCurrentForm(initialFormId);
      }
    }
  }, [formData, activeForm]);

  

  const handleChange = (formId, fieldId, value) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [formId]: {
        ...prevValues[formId],
        [fieldId]: value,
      },
    }));
  };

  const handleFileChange = async (formId, fieldId, file) => {
    const formData = new FormData();
    formData.append("userfile", file);

    try {
      const response = await axios.post(
        "https://shik-admin.zolute.xyz/api/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            // 'Cookie': 'ci_session=alclb7l263nktf37hf5elr5rcarl9csc'
          },
        }
      );

      if (response.data.status) {
        const filePath = response.data.data.key;
        setFileUploadState((prevState) => ({
          ...prevState,
          [formId]: {
            ...prevState[formId],
            [fieldId]: {
              path: filePath,
              name: file.name,
              type: file.type,
            },
          },
        }));

        alert("File added successfully");
      } else {
        alert("File upload failed");
      }
    } catch (error) {
      console.error("File upload error:", error);
      alert("File upload error. Please try again.");
    }
  };

  const handleFileRemove = (formId, fieldId) => {
    setFileUploadState((prevState) => {
      const newState = { ...prevState };
      delete newState[formId][fieldId];
      return newState;
    });
  };

  const handleNext = async () => {
    const currentFormData = formData.forms.find(
      (form) => form.id === currentForm
    );
    console.log("formValues", formValues);

    const isFormValid = currentFormData.sections.every((section) =>
      section.fields.every(
        (field) =>
          !field.required ||
          (formValues[currentForm]?.[field.id] !== undefined &&
            formValues[currentForm]?.[field.id] !== "")
      )
    );

    if (!isFormValid) {
      alert("Please fill out all required fields.");
      return;
    }

    const projectDetailsForm = formData.forms.find((form) => form.id === "A");
    const iHaveValue = formValues["A"]?.[projectDetailsForm.sections[0].fields[0].id];

    if (currentForm === "B") { 
      completeForm(currentFormData.name);
        if (iHaveValue === "Existing project") {
            setActiveForm("Technical Specification");
            setCurrentForm("E");
            return; 
        }
    }

    if (currentForm === "E") {
      completeForm(currentFormData.name);
      // const projectRequirementForm = formData.forms.find((form) => form.id === "B");
      const requirementDocValue = formValues["B"]?.[4]; 
  
      if (requirementDocValue === "Yes") {
        setActiveForm("Requirement Details");
        setCurrentForm("C");
        return;
      } else if (requirementDocValue === "No") {
        setActiveForm("Estimations");
        setCurrentForm("D");
        return;
      }
    }
    const { navigationConditions } = currentFormData;

    const andNavigation = navigationConditions.find((condition) => {
      return condition.rules.AND.every((rule) => {
        const formValue = formValues[currentForm]?.[rule.fieldid];
        if (rule.condition === "eq") {
          return formValue === rule.value;
        }
        return false;
      });
    });

    const orNavigation = navigationConditions.find((condition) => {
      return condition.rules.OR?.some((rule) => {
        const formValue = formValues[currentForm]?.id === rule.fieldid;
        console.log(
          "rule.fieldid",
          rule.fieldid,
          "formValue",
          formValue,
          "cureent",
          formValues[currentForm]?.[rule.fieldid]
        );
        if (rule.condition === "eq") {
          return formValues[currentForm]?.[rule.fieldid] === rule.value;
        }
        return false;
      });
    });

    const navigation = andNavigation || orNavigation;

    console.log("and", andNavigation, "or", orNavigation, "nav", navigation);

    if (navigation) {
      try {
        const formIdFromLocalStorage = localStorage.getItem("form_id");
        console.log("form_id_retrieved", formIdFromLocalStorage);
        const currentPostData = currentFormData.sections.reduce(
          (acc, section) => {
            section.fields.forEach((field) => {
              const value = formValues[currentForm]?.[field.id];
              if (value !== undefined) {
                acc[field.name] = value;
              }
            });
            return acc;
          },
          {}
        );

        console.log("currentPostData", currentPostData);

        const newAccumulatedData = {
          ...accumulatedData,
          ...currentPostData,
        };

        console.log("newAccumulatedData", newAccumulatedData);

        if (fileUploadState[currentForm]) {
          for (const [fieldId, filePath] of Object.entries(
            fileUploadState[currentForm]
          )) {
            const field = currentFormData.sections
              .flatMap((section) => section.fields)
              .find((field) => field.id === fieldId);
            if (field) {
              newAccumulatedData[field.name] = filePath;
            }
          }
        }

        const postData = {
          data: newAccumulatedData,
          form_id: formIdFromLocalStorage || undefined,
        };

        console.log("postdata", postData);

        const response = await axios.post(
          "https://shik-admin.zolute.xyz/api/projects",
          postData,
          {
            headers: {
              "Content-Type": "application/json",
              // 'Cookie': 'ci_session=qo1b9le3rf7i5s5jr5ne8lpvduedn6m6'
            },
          }
        );

        const formId = response.data.data[0]._id;
        localStorage.setItem("form_id", formId);
        console.log("form_id from API response:", formId);

        setFormDataArray((prevArray) => [
          ...prevArray.filter((data) => data.formId !== currentForm),
          { formId: currentForm, fields: formValues[currentForm] },
        ]);

        console.log("FormDataArray:", [
          ...formDataArray.filter((data) => data.formId !== currentForm),
          { formId: currentForm, fields: formValues[currentForm] },
        ]);

        setFormHistory((prevHistory) => [
          ...prevHistory,
          { formId: currentForm, nextForm: navigation.nextForm },
        ]);
        setCurrentForm(navigation.nextForm);
        setActiveForm(
          formData.forms.find((form) => form.id === navigation.nextForm).name
        );
        completeForm(currentFormData.name);

        setAccumulatedData(newAccumulatedData);
      } catch (error) {
        console.error("API call failed:", error);
        alert("Something went wrong. Please try again.");
      }
    } else {
      alert("Something is wrong");
    }
  };

  const handleSubmit = async () => {
    const currentFormData = formData.forms.find(
      (form) => form.id === currentForm
    );
    const isFormValid = currentFormData.sections.every((section) =>
      section.fields.every(
        (field) =>
          !field.required ||
          (formValues[currentForm]?.[field.id] !== undefined &&
            formValues[currentForm]?.[field.id] !== "")
      )
    );

    if (!isFormValid) {
      alert("Please fill out all required fields.");
      return;
    }

    try {
      const formIdFromLocalStorage = localStorage.getItem("form_id");
      const currentPostData = currentFormData.sections.reduce(
        (acc, section) => {
          section.fields.forEach((field) => {
            const value = formValues[currentForm]?.[field.id];
            if (value !== undefined) {
              acc[field.name] = value;
            }
          });
          return acc;
        },
        {}
      );

      console.log("currentPostData", currentPostData);

      const newAccumulatedData = {
        ...accumulatedData,
        ...currentPostData,
      };

      console.log("newAccumulatedData", newAccumulatedData);

      if (fileUploadState[currentForm]) {
        for (const [fieldId, filePath] of Object.entries(
          fileUploadState[currentForm]
        )) {
          const field = currentFormData.sections
            .flatMap((section) => section.fields)
            .find((field) => field.id === fieldId);
          if (field) {
            newAccumulatedData[field.name] = filePath;
          }
        }
      }

      const postData = {
        data: newAccumulatedData,
        form_id: formIdFromLocalStorage || undefined,
      };

      console.log("postdata", postData);
      const response = await axios.post(
        "https://shik-admin.zolute.xyz/api/projects",
        postData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const formId = response.data.data[0]._id;
      localStorage.setItem("form_id", formId);

      console.log("submitted form:", formSubmitted);
      console.log("visible form:", isFormVisible);
      setFormSubmitted(true);
      // setFormVisible(false);
      // setFormValues({});
      setFileUploadState({});

      // localStorage.removeItem('form_id');
    } catch (error) {
      console.error("API call failed:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  const handleBack = () => {
    setFormHistory((prevHistory) => {
      const newHistory = [...prevHistory];
      const lastHistory = newHistory.pop();
      const previousForm = lastHistory.formId;
      setCurrentForm(previousForm);
      // setActiveForm(formData.forms.find(form => form.id === previousForm).name);
      return newHistory;
    });
  };

  const renderField = (field, formId) => {
    // const isRequired = field.required === true;
    const fileTypeIcons = {
      "application/pdf": <FaFilePdf />,
      "application/msword": <FaFileWord />,
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        <FaFileWord />,
      "image/jpeg": <FaFileImage />,
      "image/png": <FaFileImage />,
    };

    const getFileIcon = (type) => fileTypeIcons[type] || <FaFilePdf />;

    switch (field.type) {
      case "DROPDOWN":
        return (
          <div key={field.id}>
            <FormLabel>{field.label}</FormLabel>
            <Select
              placeholder={field.label}
              value={formValues[formId]?.[field.id] || ""}
              onChange={(e) => handleChange(formId, field.id, e.target.value)}
              className="custom-select"
            >
              {field.options.map((option) => (
                <option key={option} value={option} className="custom-option">
                  {option}
                </option>
              ))}
            </Select>
          </div>
        );
      case "RADIO":
        return (
          <div key={field.id}>
            <FormLabel>{field.label}</FormLabel>
            <div className="radio-button-container">
              {field.options.map((option) => (
                <label
                  key={option}
                  className={`radio-button ${
                    formValues[formId]?.[field.id] === option ? "selected" : ""
                  }`}
                >
                  {option}
                  <input
                    type="radio"
                    value={option}
                    checked={formValues[formId]?.[field.id] === option}
                    onChange={() => handleChange(formId, field.id, option)}
                  />
                  {/* <span className="arrow">&#9654;</span> */}
                </label>
              ))}
            </div>
          </div>
        );
      case "TEXT":
      case "TEXTFIELD":
        return (
          <div key={field.id}>
            <FormLabel>{field.label}</FormLabel>
            <Input
              type={field.type === "text"}
              placeholder={field.label}
              name={field.name}
              value={formValues[formId]?.[field.id] || ""}
              onChange={(e) => handleChange(formId, field.id, e.target.value)}
              className="destext"
            />
          </div>
        );
      case "TEXTAREA":
        return (
          <div key={field.id}>
            <FormLabel>{field.label}</FormLabel>
            <Textarea
              placeholder={field.label}
              name={field.name}
              value={formValues[formId]?.[field.id] || ""}
              onChange={(e) => handleChange(formId, field.id, e.target.value)}
              className="destext"
            />
          </div>
        );
      case "FILE":
        return (
          <div key={field.id}>
            <FormLabel>{field.label}</FormLabel>
            {fileUploadState[formId]?.[field.id] ? (
              <div className="file-upload-success">
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    {getFileIcon(fileUploadState[formId][field.id].type)}
                  </InputLeftElement>
                  <Input
                    value={fileUploadState[formId][field.id].name}
                    isReadOnly
                    className="filetext"
                    pl="2rem"
                  />
                </InputGroup>
                <button
                  onClick={() => handleFileRemove(formId, field.id)}
                  className="remove-file-button"
                >
                  Remove File
                </button>
              </div>
            ) : (
              <Input
                type="file"
                name={field.name}
                onChange={(e) =>
                  handleFileChange(formId, field.id, e.target.files[0])
                }
                className="file-input"
              />
            )}
          </div>
        );
        case "MULTISELECT TAG":
          return (
            <div key={field.id}>
              <FormLabel>{field.label}</FormLabel>
              <MultiSelect
                options={field.options.map((option) => ({
                  value: option.value || option,
                  label: option.label || option,
                }))}
                value={formValues[formId]?.[field.id] || []}
                onChange={(selectedOptions) => {
                  handleChange(formId, field.id, selectedOptions);
                }}
                label="Choose items"
                placeholder="Select options"
                create
              />
            </div>
          );
          case "TIMEZONE":
        return (
          <div key={field.id}>
            <FormLabel>{field.label}</FormLabel>
            <Select
              placeholder="Choose Timezone"
              // id={field.id}
              value={formValues[formId]?.[field.id] || ""}
              onChange={(e) =>
                handleChange(formId, field.id, e.target.value)
              }
              className="custom-select"
            >
              {timezones.map((timezone) => (
                <option key={timezone} value={timezone} className="custom-option">
                  {timezone}
                </option>
              ))}
            </Select>
          </div>
        );
        //   case "TIMEZONE":
        // return (
        //   <FormControl key={field.id} isRequired={field.required}>
        //     <FormLabel htmlFor={field.id}>{field.label}</FormLabel>
        //     <Select
        //       placeholder={field.label}
        //       id={field.id}
        //       value={formValues[formId]?.[field.id] || ""}
        //       onChange={(e) =>
        //         handleChange(formId, field.id, e.target.value)
        //       }
              
        //     >
        //       {timezones.map((timezone) => (
        //         <option key={timezone} value={timezone}>
        //           {timezone}
        //         </option>
                
        //       ))}
              
        //     </Select>
        //   </FormControl>
        // );
      default:
        return null;
    }
  };

  const renderForm = (form) => (
    <div className="form-container" key={form.id}>
      <h2>{form.name}</h2>

      {form.sections.map((section) => (
        <div key={section.name}>
          <h3>{section.name}</h3>
          {section.fields.map((field) => (
            <FormControl key={field.id} isRequired={field.required === true}>
              {renderField(field, form.id)}
            </FormControl>
          ))}
        </div>
      ))}
      <div style={{display:"flex",justifyContent:"space-between",padding:"0.8rem"}}>
        {form.navigationConditions && form.navigationConditions.length > 0 ? (
          <button onClick={handleNext} className="next-button">
            Next
          </button>
        ) : (
          <button onClick={handleSubmit} className="submit-button">
            Submit
          </button>
        )}
        {formHistory.length > 0 && (
          <button onClick={handleBack} className="back-button">
            Back
          </button>
        )}
      </div>
    </div>
  );

  return (
    <div style={{ height: "85vh", overflowY: "auto" }}>
      {formSubmitted ? (
        <UserDataForm
          formDataArray={formDataArray}
          fileUploadState={fileUploadState}
          setFormSubmitted={setFormSubmitted}
        />
      ) : (
        formData &&
        currentForm &&
        renderForm(formData.forms.find((form) => form.id === currentForm))
      )}
    </div>
  );
};

export default DynamicForm;
